export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4015a27e1c67282fbdb35285f4859d18ec8e72c73e&name=revalidateCommunity!'